
import { GoogleGenAI } from "@google/genai";

export const getRoofingAdvice = async (userPrompt: string) => {
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY || "" });
  try {
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: userPrompt,
      config: {
        systemInstruction: "You are a helpful roofing consultant for Margate Roofing in South Florida. You answer questions about roof types (tile, shingle, metal), maintenance, storm preparation, and insurance claims. Keep answers concise, professional, and friendly. If a user asks for a quote, suggest they use the estimate form on the website or call (555) 123-4567.",
      },
    });
    return response.text || "I'm sorry, I couldn't process that. Please call us at (555) 123-4567.";
  } catch (error) {
    console.error("Gemini Error:", error);
    return "Our experts are currently offline. Please call (555) 123-4567 for immediate assistance.";
  }
};
